import { render, staticRenderFns } from "./photos.vue?vue&type=template&id=33db3eb0&"
import script from "./photos.vue?vue&type=script&lang=js&"
export * from "./photos.vue?vue&type=script&lang=js&"
import style0 from "./photos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "photos.vue"
export default component.exports